// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__XDdMt","legacyBtn":"MutateMid_legacyBtn__1gFim"};